import { ExamWritingSectionId } from '../../commonv3/types/courseExams';
import { WritingQuestionId } from '../../commonv3/types/writingQuestions';
import { MainV3ApiBase } from './base';

type AnswerSpec = {
    question_id: WritingQuestionId;
    correct: boolean;
    answer: any;
};

type SubmitRequest = {
    answers: AnswerSpec[];
};

export const WritingSectionSubmissionApis = {
    create(sectionId: ExamWritingSectionId, request: SubmitRequest): Promise<void> {
        return MainV3ApiBase.appendPath('exam_writing_sections/:sectionId/writing_section_submissions')
            .bind({ sectionId })
            .post(request);
    },
};
